import { ReactNode } from "react";
import ReactDOM from "react-dom";

export default function Toast(message:string){



    let toastRoot = document.getElementById("toast-root");
    let fadeId = new Date().getMilliseconds().toString();
    if(!toastRoot)
        return;

    toastRoot.setAttribute('data-fadeid',fadeId);
    ReactDOM.unmountComponentAtNode(toastRoot);
    ReactDOM.render(<RenderToast message={message}/>,toastRoot);
    setTimeout(() => {
        if(toastRoot&&toastRoot.getAttribute('data-fadeid')===fadeId){
         
         
            ReactDOM.unmountComponentAtNode(toastRoot);

        }

    }, 3000);


}


export  function CustomColorToast(message:string,background:string,textColor:string,icon:ReactNode,animationDuration?:string){



    let toastRoot = document.getElementById("toast-root");
    if(!toastRoot)
        return;
    let fadeId = new Date().getMilliseconds().toString();
    toastRoot.setAttribute('data-fadeid',fadeId);
    ReactDOM.unmountComponentAtNode(toastRoot);
    ReactDOM.render(<RenderCustomToast message={message} bgColor={background} txtColor={textColor} icon={icon} animDuration={animationDuration} />,toastRoot);
    setTimeout(() => {
        if(toastRoot && toastRoot.getAttribute('data-fadeid')===fadeId)
             ReactDOM.unmountComponentAtNode(toastRoot);

    }, 6000);


}

export  function ToastWithCTA(message:string,cta:string,onClickCta:()=>void,messageTwo?:string,onClickCtaTwo?:()=>void,IsPurchasedDomain?:boolean){
    let toastRoot = document.getElementById("toast-root");
    if(!toastRoot)
        return;
    
    const dismiss = ()=>{
        if(toastRoot)
             ReactDOM.unmountComponentAtNode(toastRoot);
    }
 

    ReactDOM.render(<RenderCTAToast message={message} ctaMessage={cta} onCTAClick={onClickCta} onDismiss={dismiss} ctaTwo={messageTwo} onCTAtwo={onClickCtaTwo} IsPurchasedDomain={IsPurchasedDomain}/>,toastRoot);


}

export  function ToastWithPreview(message:string,cta:string,onClickCta:()=>void){
    let toastRoot = document.getElementById("tost-preview-root");
    if(!toastRoot)
        return;
    
    const dismiss = ()=>{
        if(toastRoot)
             ReactDOM.unmountComponentAtNode(toastRoot);
    }
 

    ReactDOM.render(<RenderCTAToastPreview message={message} ctaMessage={cta} onCTAClick={onClickCta} onDismiss={dismiss}/>,toastRoot);


}

function RenderCTAToastPreview({message,ctaMessage,onCTAClick,onDismiss}:{message:string,ctaMessage:string,onCTAClick:Function,onDismiss:Function}){
    return <>
    <div className={"top-toast hanging block-edit" }>
    <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.5312 0.96875C22.1406 1.53125 22.1406 2.51562 21.5312 3.07812L9.53125 15.0781C8.96875 15.6875 7.98438 15.6875 7.42188 15.0781L1.42188 9.07812C0.8125 8.51562 0.8125 7.53125 1.42188 6.96875C1.98438 6.35938 2.96875 6.35938 3.53125 6.96875L8.45312 11.8906L19.4219 0.96875C19.9844 0.359375 20.9688 0.359375 21.5312 0.96875Z" fill="white"/></svg>
        {message}
        <button className="invisible-button toast-btn" style={{border:"1px solid white",borderRadius:"4px",marginLeft:"5px",padding:"4px 8px",whiteSpace:"nowrap",color:"white",pointerEvents:"all"}} onClick={()=>{onCTAClick();onDismiss();}}>{ctaMessage} </button>        
    </div>
    </>
}

function RenderCTAToast({message,ctaMessage,onCTAClick,onDismiss,ctaTwo,onCTAtwo,IsPurchasedDomain,duration}:{message:string,ctaMessage:string,onCTAClick:Function,onDismiss:Function,ctaTwo?:string,onCTAtwo?:Function,IsPurchasedDomain?:boolean,duration?:string}){
    return <>
    <div className={"top-toast hanging block-edit center-all" } style={(duration)?{animationDuration:duration}:{}}>
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="white"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
        {message}
        <button className="invisible-button toast-btn" style={{border:"1px solid white",borderRadius:"4px",marginLeft:"12px",padding:"4px 8px",color:"white",pointerEvents:"all"}} onClick={()=>{onCTAClick();onDismiss();}}>{ctaMessage} </button>
        {ctaTwo && onCTAtwo && IsPurchasedDomain==false &&
            <button className="invisible-button toast-btn" style={{border:"1px solid white",borderRadius:"4px",marginLeft:"12px",padding:"4px 8px",color:"white",pointerEvents:"all"}} onClick={()=>{onCTAtwo();onDismiss();}}>{ctaTwo} </button>
        }
        
        
        <button className="invisible-button center-all" style={{position:"absolute",right:"12px",top:"0",height:"100%",color:"white",pointerEvents:"all",fontSize:"30px",fontWeight:"bold"}} onClick={()=>onDismiss()}>&times;</button>
    </div>
    
    
    </>



}


function RenderToast({message}:{message:ReactNode}){


    return <>
    <div className={"top-toast" }>
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="white"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
        {message}
    </div>
    
    
    </>



}

function RenderCustomToast({message,bgColor,icon,txtColor,animDuration}:{message:ReactNode,bgColor:string,icon:ReactNode,txtColor:string,animDuration?:string}){


    return <>
    <div className={"top-toast" } style={{background:bgColor,color:txtColor,zIndex:2000,animationDuration:animDuration}}>
    {icon}
        {message}
    </div>
    
    
    </>



}